import { c as _c } from "react/compiler-runtime";
import { Button, FilterIcon, FilterWithBadgeIcon, IconButton } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
/** Button to show or hide the filter chips, with a badge while hidden filters still apply */
export function FilterToggleButton(t0) {
  const $ = _c(14);
  const {
    isOpen,
    onToggle,
    isIconOnly: t1
  } = t0;
  const isIconOnly = t1 === undefined ? false : t1;
  const {
    isAnyFilterApplied
  } = useFilterQueryParams();
  let t2;
  if ($[0] !== isAnyFilterApplied || $[1] !== isOpen) {
    t2 = !isOpen && isAnyFilterApplied ? <FilterWithBadgeIcon /> : <FilterIcon />;
    $[0] = isAnyFilterApplied;
    $[1] = isOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const icon = t2;
  if (isIconOnly) {
    let t3;
    if ($[3] !== icon || $[4] !== isOpen || $[5] !== onToggle) {
      t3 = <IconButton size="s" aria-label="Filters" aria-expanded={isOpen} pressed={isOpen} onClick={onToggle}>{icon}</IconButton>;
      $[3] = icon;
      $[4] = isOpen;
      $[5] = onToggle;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const t3 = isOpen ? "action.selected" : undefined;
  let t4;
  if ($[7] !== t3) {
    t4 = {
      backgroundColor: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== icon || $[10] !== isOpen || $[11] !== onToggle || $[12] !== t4) {
    t5 = <Button variant="neutralGhost" size="s" icon={icon} aria-expanded={isOpen} onClick={onToggle} sx={t4}>Filters</Button>;
    $[9] = icon;
    $[10] = isOpen;
    $[11] = onToggle;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}